import { render, staticRenderFns } from "./StepContact.vue?vue&type=template&id=52b753ee&scoped=true"
import script from "./StepContact.vue?vue&type=script&lang=ts"
export * from "./StepContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b753ee",
  null
  
)

export default component.exports